import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { MotionReveal } from "./MotionReveal";

const ORDER = [
  {
    key: "salud",
    image: "/img/medical.jpg",
    label: { es: "Salud", en: "Health" },
  },
  {
    key: "industria",
    image: "/img/factory.jpg",
    label: { es: "Industria", en: "Industry" },
  },
  {
    key: "comercio",
    image: "/img/shop.jpg",
    label: { es: "Comercio", en: "Commerce" },
  },
  {
    key: "movilidad",
    image: "/img/delivery.jpg",
    label: { es: "Movilidad", en: "Mobility" },
  },
  {
    key: "corporativo",
    image: "/img/office.jpg",
    label: { es: "Corporativo", en: "Corporate" },
  },
];

export function Sectors() {
  const { t, i18n } = useTranslation("global");
  const lang = i18n.language?.startsWith("en") ? "en" : "es";
  const [active, setActive] = useState(0);

  const sectors = useMemo(
    () =>
      ORDER.map((item) => ({
        ...item,
        data: t(`sectors.${item.key}`, { returnObjects: true }),
        label: item.label[lang],
      })),
    [t, lang]
  );

  const current = sectors[active];
  if (!current?.data) return null;

  return (
    <section className="siat-section siat-section--alt" id="sectors">
      <div className="siat-wrap">
        <MotionReveal className="siat-intro siat-intro--center">
          <p className="siat-eyebrow">{t("navigation.sectors")}</p>
          <h2>{t("sectors.heading")}</h2>
          <p className="siat-lead">{t("sectors.lead")}</p>
        </MotionReveal>

        <div className="siat-tabs" role="tablist" aria-label={t("navigation.sectors")}>
          {sectors.map((sector, index) => (
            <button
              key={sector.key}
              type="button"
              role="tab"
              aria-selected={index === active}
              className={index === active ? "is-active" : undefined}
              onClick={() => setActive(index)}
            >
              {sector.label}
            </button>
          ))}
        </div>

        <MotionReveal key={current.key} className="siat-sector-board" id={current.key}>
          <div>
            <p className="siat-eyebrow">{current.label}</p>
            <h3>{current.data.title}</h3>
            {current.data.subtitle ? (
              <p className="siat-lead">{current.data.subtitle}</p>
            ) : null}
            <ul className="siat-bullets">
              {(current.data.features || []).map((feature) => (
                <li key={feature.title}>
                  <strong>{feature.title}</strong>
                  <span>{feature.text}</span>
                </li>
              ))}
            </ul>
            {current.data.closing ? (
              <p className="siat-note">
                {current.data.highlight ? (
                  <mark className="siat-mark">{current.data.highlight}</mark>
                ) : null}{" "}
                {current.data.closing}
              </p>
            ) : null}
            <a className="siat-btn siat-btn--primary" href="#contact">
              {t("sectors.cta")}
            </a>
          </div>

          <figure className="siat-sector-board__media">
            <img
              key={current.image}
              src={current.image}
              alt=""
              loading="lazy"
            />
            <figcaption>{current.label}</figcaption>
          </figure>
        </MotionReveal>
      </div>
    </section>
  );
}
